import React from 'react';
import { StudyFormContext } from '@/features/studies/contexts/StudyFormContext';
import { StudyEditFormProps } from '../types/study-edit.interface';

export type StudyFormContextType = StudyEditFormProps;

type StudyFormProviderProps = StudyEditFormProps & {
  children: React.ReactNode;
};

export const StudyFormProvider: React.FC<StudyFormProviderProps> = ({
  children,
  ...form
}) => {
  return (
    <StudyFormContext.Provider value={form}>
      {children}
    </StudyFormContext.Provider>
  );
};
